export function joinForm() {
    $(window).on("load", function () {
        const form = document.querySelector('#sib-form');
        const jcfSelect = document.querySelector('.jcf-hidden');

        $(form).find('.entry__field input, .entry__field select').focus(function () {
            $(this).closest('.sib-form-block').addClass('focused');

        }).blur(function () {
            $(this).closest('.sib-form-block').removeClass('focused');

            if (!$(this).val()) {
                $(this).closest('.sib-form-block').removeClass('not-empty');
            } else {
                $(this).closest('.sib-form-block').addClass('not-empty');
            }
        });

        if ($(jcfSelect).length) {
            $(jcfSelect).on('change', function () {
                $(form).find('.sib-select.sib-form-block').addClass('not-empty');
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/joinForm.js